export class FaqCreate {
    public category: string;
    public target: string;
    public question: string;
    public answer: string;
    public priority: number;
}
